import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=72bf4bca&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72bf4bca')) {
      api.createRecord('72bf4bca', component.options)
    } else {
      api.reload('72bf4bca', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=72bf4bca&", function () {
      api.rerender('72bf4bca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2A7KW0VmcxbPA/JS/comp/ImgFallback.vue"
export default component.exports